import * as React from "react";

const LightTheme: React.FC = () => {
  React.useEffect(() => {
    // a regular import results in the light stylesheet being loaded even when the theme is dark
    require("../assets/sass/light.less");
  }, []);

  return <></>;
};

export default LightTheme;
